import Consts from '@/common/consts'
export default {
  HOT_SEARCH: `${Consts.API_HOST_MAIN}/adVip/qryHotKw`, // 热门搜索
  SEARCH: `${Consts.API_HOST_MAIN}/adVip/searchGoodsBykw`, // 搜索
  
  TAB_LIST: `${Consts.API_HOST_MAIN}/adVip/qryTab`, // tab菜单

  TAB_GOODS_LIST: `${Consts.API_HOST_MAIN}/adVip/qryTabGoods`, // tab菜单对应的商品列表

  GOODS_DETAIL: `${Consts.API_HOST_MAIN}/adVip/qryAdGoodsDetail`, // 商品详情
  GOODS_DETAIL_BUY_URL: `${Consts.API_HOST_MAIN}/adVip/qryGoodsBuyUrl`, // 查询商品购买url

  BEAN_BALANCE: `${Consts.API_HOST_MAIN}/adVip/qryGoldenBeans`, // 金豆合计
  BEAN_LIST: `${Consts.API_HOST_MAIN}/adVip/qryGoldenBeansList`, // 金豆列表
  SETTLED_PROFIT_BALANCE: `${Consts.API_HOST_MAIN}/adVip/qryCommissionEnrolled`, // 已结算收益合计
  SETTLED_PROFIT_LIST: `${Consts.API_HOST_MAIN}/adVip/qryCommissionEnrolledList`, // 已结算收益列表
  UNSETTLED_PROFIT_BALANCE: `${Consts.API_HOST_MAIN}/adVip/qryCommissionUnbooked`, // 待结算收益合计
  UNSETTLED_PROFIT_LIST: `${Consts.API_HOST_MAIN}/adVip/qryCommissionUnbookedList`, // 待结算收益列表
  
  ORDER_LIST: `${Consts.API_HOST_MAIN}/adVip/qryOrders`, // 我的订单
  TEAM_ORDER_LIST: `${Consts.API_HOST_MAIN}/adVip/qryTeamOrders`, // 团队订单
}
